import type { JsonLdValue } from "@/src/common/types/json-ld";
import { SITE_CONFIG, SITE_ORIGIN } from "./site-config";
import { SITE_ROUTES } from "./site-routes";

const ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;
const WEBSITE_ID = `${SITE_ORIGIN}/#website`;

const ORGANIZATION_SCHEMA: JsonLdValue = {
	"@type": "Organization",
	"@id": ORGANIZATION_ID,
	name: SITE_CONFIG.name,
	legalName: SITE_CONFIG.legalName,
	url: SITE_ORIGIN,
	logo: `${SITE_ORIGIN}/apple-touch-icon.png`,
	email: SITE_CONFIG.contactEmail,
	address: {
		"@type": "PostalAddress",
		streetAddress: SITE_CONFIG.address.line1,
		addressLocality: SITE_CONFIG.address.city,
		addressRegion: SITE_CONFIG.address.state,
		postalCode: SITE_CONFIG.address.zip,
		addressCountry: SITE_CONFIG.address.country,
	},
	contactPoint: {
		"@type": "ContactPoint",
		contactType: "sales",
		email: SITE_CONFIG.contactEmail,
		url: `${SITE_ORIGIN}${SITE_ROUTES.CONTACT}`,
	},
	sameAs: [SITE_CONFIG.socials.linkedin, SITE_CONFIG.socials.x],
};

const WEBSITE_SCHEMA: JsonLdValue = {
	"@type": "WebSite",
	"@id": WEBSITE_ID,
	name: SITE_CONFIG.name,
	url: SITE_ORIGIN,
	inLanguage: ["en", "es"],
	publisher: { "@id": ORGANIZATION_ID },
};

const buildSoftwareApplicationSchema = (description: string): JsonLdValue => ({
	"@type": "SoftwareApplication",
	name: SITE_CONFIG.name,
	description,
	url: SITE_ORIGIN,
	applicationCategory: "BusinessApplication",
	operatingSystem: "Web, iOS, Android",
	publisher: { "@id": ORGANIZATION_ID },
	offers: {
		"@type": "Offer",
		price: "0",
		priceCurrency: "USD",
		category: "free",
		url: `${SITE_ORIGIN}${SITE_ROUTES.PRICING}`,
	},
});

export const buildHomeStructuredData = (description: string): JsonLdValue => ({
	"@context": "https://schema.org",
	"@graph": [ORGANIZATION_SCHEMA, WEBSITE_SCHEMA, buildSoftwareApplicationSchema(description)],
});
